// extracted by mini-css-extract-plugin
module.exports = {"template":"Template_template__qQdlv","history":"Template_history__1NHG7","reEdit":"Template_reEdit__37I_B"};